import React from 'react';
import { Link } from "gatsby"
import { People_Email } from "../../queries/common_use_query"
import './assets/styles/_index.scss';
import NegoImg from "../../images/property-nego.png"
import { bookViewingURL, makeEnquiryURL } from '../../site/urls';
import { getWhatsAppURL, getWhatsAppTEXT } from '../../site/utils';


// Negotiator details
const NegoDetailsData = (email_id) => {

    const { loading, error, data } = People_Email(email_id);

    // console.log("nego_info ==>", data);
    return data;
}
// Negotiator details

const PropertyNego = (props) => {

    var nego_info = props?.propertyData?.crm_negotiator_id && props?.propertyData?.crm_negotiator_id?.email && NegoDetailsData(props?.propertyData?.crm_negotiator_id?.email);
    const pId = props?.propertyData?.id

    // const { loading, error, data } = People_Email(props?.propertyData?.crm_negotiator_id?.email);
    var negInfo = {
        name: props?.propertyData?.crm_negotiator_id?.name,
        email: props?.propertyData?.crm_negotiator_id?.email,
        phone: props?.propertyData?.crm_negotiator_id?.phone,
        designation: null,
        image: null
    };
    if (nego_info && nego_info?.teams && nego_info?.teams?.length > 0) {
        let team = nego_info?.teams[0]
        negInfo.name = team.name;
        negInfo.email = team.email;
        negInfo.phone = team.mobile_no ? team.mobile_no : negInfo.phone;
        negInfo.designation = team.designation;
        negInfo.image = team.image;
    }
    // console.log("$$$$$$$$-----email-----", nego_info, props?.propertyData?.crm_negotiator_id?.email, negInfo)
    if (negInfo && !props.isMobile) {
        return (
            <div className="property-nego-wrapper">
                {negInfo.image &&
                    <div className="nego-img-wrapper">
                        <img src={negInfo.image?.url} alt="nego-img" />
                    </div>
                }
                <div className="nego-name-details">
                    <div className="nego-name">{negInfo?.name}</div>
                    <div className="nego-desig">{negInfo.designation}</div>
                </div>
                <div className="nego-btn-wrapper">
                    {
                        props.holidaySidebar === "holiday-homes" ?
                            <Link to={`${makeEnquiryURL}?pid=${pId}`} className="button button-secondary">Make Enquiry</Link>
                            :
                            <>
                                <Link to={`${bookViewingURL}?pid=${pId}`} className="button button-primary"><i className="icon icon-nego-mail"></i> Email Agent</Link>
                                {negInfo?.phone &&
                                    <>
                                        <a href={"tel:" + negInfo?.phone} className="button button-secondary"><i className="icon icon-nego-phone"></i> {negInfo?.phone}</a>
                                        <a href={`${getWhatsAppURL(negInfo?.phone)}?text=${getWhatsAppTEXT(props)}`} target="_blank" className="button button-secondary mb-0"><i className="icon icon-nego-whatsapp"></i> Click to Whatsapp</a>
                                    </>
                                }
                            </>
                    }
                </div>
            </div>
        )
    } else if (negInfo && props.isMobile) {
        return (
            <div className="d-flex align-items-center">
                {negInfo.image &&
                    <div className="property-nego-img-wrapper">
                        <img src={negInfo.image?.url} alt="nego-img" />
                    </div>
                }
                <div className="property-nego-name-details">
                    <div className="property-nego-name">{negInfo?.name}</div>
                    <div className="property-nego-desig">{negInfo.designation}</div>
                </div>
            </div>
        )
    } else {
        return <></>
    }
}

export default PropertyNego